import React from 'react';

import { CommercialMultiAdsTitle } from '../../../../components/Commercial/CommercialMultiAdsTitle';
import { CommercialTitle } from '../../../../components/Commercial/CommercialTitle';
import { useOfferContext } from '../../../../context';
import { getCommercialHeading4Parts } from '../../../../utils/computedProps/commercial/getCommercialHeading4Parts';
import { getCommercialPromoTitle } from '../../../../utils/computedProps/commercial/getCommercialPromoTitle';
import { getMultiAdsAvailability } from '../../../../utils/computedProps/commercial/multiAds/getMultiAdsAvailability';
import { getMultiAdsSubtitle } from '../../../../utils/computedProps/commercial/multiAds/getMultiAdsSubtitle';
import { isCommercialMultiAds } from '../../../../utils/computedProps/commercial/multiAds/isCommercialMultiAds';
import { isCianPartner as isCianPartnerUtil } from 'shared/utils/dailyrent/isCianPartner';

const HEADING4_SEPARATOR = '・';

export function CommercialTitleContainer() {
  const { offer } = useOfferContext();
  const { fullUrl, externalOfferUrl } = offer;

  const isCianPartner = isCianPartnerUtil(offer);
  const href = isCianPartner ? externalOfferUrl : fullUrl;
  const rel = isCianPartner ? 'noreferrer nofollow noindex' : 'noreferrer';

  if (isCommercialMultiAds(offer)) {
    const title = getCommercialPromoTitle(offer);
    const subtitle = getMultiAdsSubtitle(offer);
    const availability = getMultiAdsAvailability(offer);

    if (!title && !subtitle && !availability) {
      return null;
    }

    return (
      <CommercialMultiAdsTitle title={title} subtitle={subtitle} availability={availability} href={href} rel={rel} />
    );
  }

  const promoTitle = getCommercialPromoTitle(offer);
  const typedParts = getCommercialHeading4Parts(offer);

  const normalizedPromo = promoTitle?.trim().toLocaleLowerCase();
  const dedupedTypedParts =
    normalizedPromo && typedParts[0]?.toLocaleLowerCase() === normalizedPromo ? typedParts.slice(1) : typedParts;
  const typedTitle = dedupedTypedParts.join(HEADING4_SEPARATOR);
  const isPromoted = Boolean(offer.isPremium || offer.isTop3);

  if (!typedTitle && !promoTitle) {
    return null;
  }

  return (
    <CommercialTitle promoTitle={promoTitle} typedTitle={typedTitle} href={href} rel={rel} isPromoted={isPromoted} />
  );
}

CommercialTitleContainer.displayName = 'CommercialTitleContainer';
